module.exports = __webpack_public_path__ + "img/20200424145100356.72814d40.png";